<!--Line with Area Chart 1 Starts-->
<div class="row ">
    <div class="col-sm-12">
        <div class="content-header">Chartist</div>
        <p class="content-sub-header">Angular component for Chartist.js</p>
    </div>
</div>
<div class="row text-left">
    <div class="col-sm-12">
        <div class="card">
            <div class="card-header">
                <h4 class="card-title">Line with Area Chart</h4>
            </div>
            <div class="card-content">
                <div class="card-body">
                    <div id="line-area1" class="lineArea1">
                        <x-chartist class="height-400" [data]="lineArea1.data" [type]="lineArea1.type" [options]="lineArea1.options" [responsiveOptions]="lineArea1.responsiveOptions"
                            [events]="lineArea1.events">
                        </x-chartist>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!--Line with Area Chart 1 Ends-->
<!--Line with Area Chart 2 Starts-->
<div class="row text-left">
    <div class="col-sm-12">
        <div class="card">
            <div class="card-header">
                <h4 class="card-title">Line with Area Chart</h4>
            </div>
            <div class="card-content">
                <div class="card-body">
                    <div id="line-area2" class="lineArea2">
                        <x-chartist class="height-400" [data]="lineArea2.data" [type]="lineArea2.type" [options]="lineArea2.options"
                            [responsiveOptions]="lineArea2.responsiveOptions" [events]="lineArea2.events">
                        </x-chartist>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!--Line with Area Chart 2 Ends-->
<!--Line with Area Chart 3 Starts-->
<div class="row text-left">
    <div class="col-sm-12">
        <div class="card">
            <div class="card-header">
                <h4 class="card-title">Line with Area Chart</h4>
            </div>
            <div class="card-content">
                <div class="card-body">
                    <div id="line-area3" class="lineArea3">
                        <x-chartist class="height-400" [data]="lineArea3.data" [type]="lineArea3.type" [options]="lineArea3.options"
                            [responsiveOptions]="lineArea3.responsiveOptions" [events]="lineArea3.events">
                        </x-chartist>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!--Line with Area Chart 3 Ends-->
<!--Line with Area Chart 4 Starts-->
<div class="row text-left">
    <div class="col-sm-12">
        <div class="card">
            <div class="card-header">
                <h4 class="card-title">Line with Area Chart</h4>
            </div>
            <div class="card-content">
                <div class="card-body">
                    <div id="line-area4" class="">
                        <x-chartist class="height-400" [data]="lineArea4.data" [type]="lineArea4.type" [options]="lineArea4.options"
                            [responsiveOptions]="lineArea4.responsiveOptions" [events]="lineArea4.events">
                        </x-chartist>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!--Line with Area Chart 4 Ends-->
<!--Line Chart 1 Starts-->
<div class="row text-left">
    <div class="col-sm-12">
        <div class="card">
            <div class="card-header">
                <h4 class="card-title">Line Chart</h4>
            </div>
            <div class="card-content">
                <div class="card-body">
                    <div id="line-chart1" class="lineChart1 lineChart1Shadow">
                        <x-chartist class="height-400" [data]="lineChart1.data" [type]="lineChart1.type" [options]="lineChart1.options"
                            [responsiveOptions]="lineChart1.responsiveOptions" [events]="lineChart1.events">
                        </x-chartist>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!--Line Chart 1 Ends-->
<!--Line Chart 2 Starts-->
<div class="row text-left">
    <div class="col-sm-12">
        <div class="card">
            <div class="card-header">
                <h4 class="card-title">Line Chart</h4>
            </div>
            <div class="card-content">
                <div class="card-body">
                    <div id="line-chart2" class=" lineChart2 shadow">
                        <x-chartist class="height-400" [data]="lineChart2.data" [type]="lineChart2.type" [options]="lineChart2.options"
                            [responsiveOptions]="lineChart2.responsiveOptions" [events]="lineChart2.events">
                        </x-chartist>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!--Line Chart 2 Ends-->
<!--Line Chart 3 Starts-->
<div class="row text-left">
    <div class="col-sm-12">
        <div class="card">
            <div class="card-header">
                <h4 class="card-title">Line Chart</h4>
            </div>
            <div class="card-content">
                <div class="card-body">
                    <div id="line-chart3" class="">
                        <x-chartist class="height-400" [data]="lineChart3.data" [type]="lineChart3.type" [options]="lineChart3.options" [responsiveOptions]="lineChart3.responsiveOptions"
                            [events]="lineChart3.events">
                        </x-chartist>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!--Line Chart 3 Ends-->
<!--Scatter Line Chart Starts-->
<div class="row text-left">
    <div class="col-sm-12">
        <div class="card">
            <div class="card-header">
                <h4 class="card-title">Scatter Line Chart</h4>
            </div>
            <div class="card-content">
                <div class="card-body">
                    <div id="scatter -line-chart" class="">
                        <x-chartist class="height-400" [data]="scatterlineChart.data" [type]="scatterlineChart.type" [options]="scatterlineChart.options" [responsiveOptions]="scatterlineChart.responsiveOptions"
                            [events]="scatterlineChart.events">
                        </x-chartist>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!--Scatter Line Chart Ends-->
<!--Scatter Chart Starts-->
<div class="row text-left">
    <div class="col-sm-12">
        <div class="card">
            <div class="card-header">
                <h4 class="card-title">Scatter Chart</h4>
            </div>
            <div class="card-content">
                <div class="card-body">
                    <div id="scatter-chart2" class="">
                        <x-chartist class="height-400" [data]="scatterChart.data" [type]="scatterChart.type" [options]="scatterChart.options" [responsiveOptions]="scatterChart.responsiveOptions"
                            [events]="scatterChart.events">
                        </x-chartist>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!--Scatter Chart Ends-->
<!--Bi-polar Line Chart Starts-->
<div class="row text-left">
    <div class="col-sm-12">
        <div class="card">
            <div class="card-header">
                <h4 class="card-title">Bi-polar Line Chart</h4>
            </div>
            <div class="card-content">
                <div class="card-body">
                    <div id="bi-polar-chart" class="">
                        <x-chartist class="height-400" [data]="biPolarLineChart.data" [type]="biPolarLineChart.type" [options]="biPolarLineChart.options" [responsiveOptions]="biPolarLineChart.responsiveOptions"
                            [events]="biPolarLineChart.events">
                        </x-chartist>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!--Bi-polar Line Chart Ends-->
<!--Bar Chart Starts-->
<div class="row text-left">
    <div class="col-sm-12">
        <div class="card">
            <div class="card-header">
                <h4 class="card-title">Bar Chart</h4>
            </div>
            <div class="card-content">
                <div class="card-body">
                    <div id="bar-chart" class="">
                        <x-chartist class="height-400" [data]="barChart.data" [type]="barChart.type" [options]="barChart.options" [responsiveOptions]="barChart.responsiveOptions"
                            [events]="barChart.events">
                        </x-chartist>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!--Bar Chart Ends-->
<!--Distributed Series Bar Chart Starts-->
<div class="row text-left">
    <div class="col-sm-12">
        <div class="card">
            <div class="card-header">
                <h4 class="card-title">Distributed Series Bar Chart</h4>
            </div>
            <div class="card-content">
                <div class="card-body">
                    <div id="distributed-bar-chart" class="">
                        <x-chartist class="height-400" [data]="distributedSeriesBarChart.data" [type]="distributedSeriesBarChart.type" [options]="distributedSeriesBarChart.options"
                            [responsiveOptions]="distributedSeriesBarChart.responsiveOptions" [events]="distributedSeriesBarChart.events">
                        </x-chartist>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!--Distributed Series Bar Chart Ends-->
<!--Donut Chart 1 Starts-->
<div class="row text-left">
    <div class="col-sm-12">
        <div class="card">
            <div class="card-header">
                <h4 class="card-title">Donut Chart</h4>
            </div>
            <div class="card-content">
                <div class="card-body">
                    <div id="donut-chart1" class="">
                        <x-chartist class="height-400" [data]="donutChart1.data" [type]="donutChart1.type" [options]="donutChart1.options" [responsiveOptions]="donutChart1.responsiveOptions"
                            [events]="donutChart1.events">
                        </x-chartist>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!--Donut Chart 1 Ends-->
<!--Donut Chart 2 Starts-->
<div class="row text-left">
    <div class="col-sm-12">
        <div class="card">
            <div class="card-header">
                <h4 class="card-title">Donut Chart</h4>
            </div>
            <div class="card-content">
                <div class="card-body">
                    <div id="donut-chart2" class="">
                        <x-chartist class="height-400" [data]="donutChart2.data" [type]="donutChart2.type" [options]="donutChart2.options" [responsiveOptions]="donutChart2.responsiveOptions"
                            [events]="donutChart2.events">
                        </x-chartist>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!--Donut Chart 2 Ends-->
